import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import AssetsTable from "../../containers/domain/asset/AssetsTable";

const AssetsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard title="Lista de ativos" content={<AssetsTable />} />
    </ItemGrid>
  </GridContainer>
);

export default AssetsListingView;
